import PropTypes from 'prop-types'
import { FormControl } from 'baseui/form-control'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { useTranslation } from 'react-i18next'

const ZohoClientDataImporter = ({ fetchZohoClient, disabled, isImporting, hidden }) => {
  const { t } = useTranslation()
  const handleClick = async e => {
    e.preventDefault()
    const confirmation = confirm(t('subscriptionForm:customer_module.zoho_client_fetcher.confirmation'))
    if (!confirmation) {
      return
    }
    fetchZohoClient()
  }

  if (hidden) {
    return null
  }

  return (
    <FormControl>
      <SDButton
        style={{ marginTop: '0.5rem' }}
        disabled={disabled || isImporting}
        isLoading={isImporting}
        block={true}
        onClick={handleClick}
      >
        {t('subscriptionForm:customer_module.zoho_client_fetcher.label')}
      </SDButton>
    </FormControl>
  )
}

ZohoClientDataImporter.propTypes = {
  fetchZohoClient: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isImporting: PropTypes.bool,
  hidden: PropTypes.bool,
}

export default ZohoClientDataImporter
